import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismCard, PrismDataBar } from '@mylighthouse/prism-ember';
import {
  COLOR_TRAFFIC_LIGHT_NEGATIVE,
  COLOR_TRAFFIC_LIGHT_NEUTRAL,
  COLOR_TRAFFIC_LIGHT_POSITIVE,
  getCssVariableValue,
} from 'frontend-utils/utils/css-variable';
import GeneralButtonsOtbSelfServiceButton from 'lumen/components/general/buttons/otb-self-service-button';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import {
  OTB_SS_ENTRY_POINTS,
  OTB_SS_VIA_QP_VALUES,
} from 'lumen/utils/constants/otb-selfservice-constants';

import styles from './short-term-rental-kpi-list.module.css';

interface HotelShortTermRentalShortTermRentalKpiListSignature {
  Args: {
    isLoading: unknown;
    kpis: unknown;
  };
}

export default class HotelShortTermRentalShortTermRentalKpiList extends Component<HotelShortTermRentalShortTermRentalKpiListSignature> {
  @service declare access: Services['access'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get kpiList() {
    if (this.args.isLoading || !this.args.kpis) {
      return [{}, {}, { isLargeBlock: true }, {}];
    }

    const kpis = {
      occupancy: {},
      rate: {},
      beds: {},
      listings: {},
    };

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.kpis?.forEach((obj) => {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      obj.forEach((kpi) => {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        kpis[kpi.type][kpi.subtype] = kpi;
      });
    });
    const { beds, listings, occupancy, rate } = kpis;
    return [
      {
        title: this.intl.t('short_term_rental.kpi.rentals'),
        leftColumn: {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value: listings.relevant.formattedValue,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          change: listings.relevant.formattedChange,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          changeClass: listings.relevant.colorClass,
          label: this.intl.t('short_term_rental.kpi.relevant'),
          visible: true,
          tooltipMessage: this.intl.t(
            'short_term_rental.tooltip.kpi.rentals_relevant',
          ),
        },
        rightColumn: {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value: listings.total.formattedValue,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          change: listings.total.formattedChange,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          changeClass: listings.total.colorClass,
          label: this.intl.t('revenue_insight.total'),
          visible: true,
        },
      },
      {
        title: this.intl.t('short_term_rental.kpi.beds'),
        leftColumn: {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value: beds.relevant?.formattedValue,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          change: beds.relevant?.formattedChange,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          changeClass: beds.relevant?.colorClass,
          label: this.intl.t('short_term_rental.kpi.relevant'),
          visible: true,
          tooltipMessage: this.intl.t(
            'short_term_rental.tooltip.kpi.beds_relevant',
          ),
        },
        rightColumn: {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value: beds.total?.formattedValue,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          change: beds.total?.formattedChange,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          changeClass: beds.total?.colorClass,
          label: this.intl.t('revenue_insight.total'),
          visible: true,
        },
      },
      {
        title: this.intl.t('general.occupancy'),
        showUpsell: this.access.hasFeature('otb.empty_placeholder'),
        leftColumn: {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value: occupancy.shorttermrental.formattedValue,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          change: occupancy.shorttermrental.formattedChange,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          changeClass: occupancy.shorttermrental.colorClass,
          label: this.intl.t('short_term_rental.kpi.relevant_rentals'),
          visible: true,
          progressBarData: [
            {
              backgroundColor: getCssVariableValue(COLOR_TRAFFIC_LIGHT_NEUTRAL),
              // @ts-expect-error: Incorrect type
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              widthPercentage: occupancy.shorttermrental.value * 100,
            },
            {
              backgroundColor:
                // @ts-expect-error: Incorrect type
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                occupancy.shorttermrental.difference < 0
                  ? getCssVariableValue(COLOR_TRAFFIC_LIGHT_NEGATIVE)
                  : getCssVariableValue(COLOR_TRAFFIC_LIGHT_POSITIVE),
              widthPercentage: Math.round(
                // @ts-expect-error: Incorrect type
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
                Math.abs(occupancy.shorttermrental.difference) * 100,
              ),
            },
          ],
        },
        rightColumn: {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value: occupancy.ownhotel?.formattedValue,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          change: occupancy.ownhotel?.formattedChange,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          changeClass: occupancy.ownhotel?.colorClass,
          label: this.intl.t('general.my_hotel'),
          visible: this.access.hasOTB,
          progressBarData: [
            {
              backgroundColor: getCssVariableValue(COLOR_TRAFFIC_LIGHT_NEUTRAL),
              // @ts-expect-error: Incorrect type
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              widthPercentage: occupancy.ownhotel?.value * 100,
            },
            {
              backgroundColor:
                // @ts-expect-error: Incorrect type
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                occupancy.ownhotel?.difference < 0
                  ? getCssVariableValue(COLOR_TRAFFIC_LIGHT_NEGATIVE)
                  : getCssVariableValue(COLOR_TRAFFIC_LIGHT_POSITIVE),
              widthPercentage: Math.round(
                // @ts-expect-error: Incorrect type
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
                Math.abs(occupancy.ownhotel?.difference) * 100,
              ),
            },
          ],
        },
      },
      {
        title: this.intl.t('short_term_rental.kpi.median_rate'),
        tooltipMessage: this.intl.t(
          'short_term_rental.tooltip.kpi.average_rate',
        ),
        leftColumn: {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value: rate.shorttermrental.formattedValue,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          change: rate.shorttermrental.formattedDifferenceRate,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          changeClass: rate.shorttermrental.colorClass,
          label: this.intl.t('short_term_rental.kpi.relevant_rentals'),
          visible: true,
        },
        rightColumn: {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          value: rate.ownhotel.formattedValue,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          change: rate.ownhotel.formattedDifferenceRate,
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          changeClass: rate.ownhotel.colorClass,
          label: this.intl.t('general.my_hotel'),
          visible: true,
        },
      },
    ];
  }

  <template>
    {{! @glint-nocheck }}
    <div class={{styles.list}}>
      {{#each this.kpiList as |item|}}
        {{#if @isLoading}}
          <PrismCard>
            <:header>
              <div class="{{styles.loading-header}} flex items-center">
                <span class={{styles.loading-bar}}></span>
              </div>
            </:header>

            <:content>
              <div
                class="{{styles.loading-content}}
                  flex flex-row
                  {{if item.isLargeBlock styles.loading-content--large}}
                  "
              >
                <div class="mr-500 w-1/2">
                  <span slot="metric-value">
                    <span class={{styles.loading-bar}}></span>
                  </span>
                  <span class="flex flex-row">
                    <span class="{{styles.loading-bar}} mt-300 w-2/3"></span>
                  </span>
                </div>
                <div class="mr-500 w-1/2">
                  <span slot="metric-value">
                    <span class={{styles.loading-bar}}></span>
                  </span>
                  <span class="flex flex-row">
                    <span class="{{styles.loading-bar}} mt-300 w-2/3"></span>
                  </span>
                </div>
              </div>
            </:content>
          </PrismCard>
        {{else}}
          <PrismCard>
            <:header as |Header|>
              <div class="flex items-center gap-100">
                <Header.title>{{item.title}}</Header.title>
                {{#if item.tooltipMessage}}
                  <GeneralIconWithTooltip
                    @side="top"
                    @tooltipContent={{item.tooltipMessage}}
                  />
                {{/if}}
              </div>
            </:header>

            <:headerAfter>
              {{#if item.showUpsell}}
                <GeneralButtonsOtbSelfServiceButton
                  @otbSelfServiceEntryPoint={{OTB_SS_ENTRY_POINTS.RENTAL_CARD}}
                  @otbSelfServiceEntryProduct={{OTB_SS_VIA_QP_VALUES.RATE_INSIGHT}}
                />
              {{/if}}
            </:headerAfter>

            <:content>
              <div class="flex flex-row">
                <div
                  class="{{if item.rightColumn.visible 'w-1/2' 'w-full'}}
                    mr-300"
                >
                  <span class="text-400--bold">
                    {{item.leftColumn.value}}
                  </span>
                  <span
                    class="text-200--regular {{item.leftColumn.changeClass}} "
                  >
                    {{item.leftColumn.change}}
                  </span>
                  {{#if item.leftColumn.progressBarData}}
                    <div class="mt-100">
                      <PrismDataBar @data={{item.leftColumn.progressBarData}} />
                    </div>
                  {{/if}}
                  <span class="{{styles.label}} flex items-center gap-100">
                    <span class="text-200--regular truncate">
                      {{item.leftColumn.label}}
                    </span>
                    {{#if item.leftColumn.tooltipMessage}}
                      <GeneralIconWithTooltip
                        @side="bottom"
                        @tooltipContent={{item.leftColumn.tooltipMessage}}
                      />
                    {{/if}}
                  </span>
                </div>
                {{#if item.rightColumn.visible}}
                  <div class="mr-300 w-1/2">
                    <span class="text-400--regular">
                      {{item.rightColumn.value}}
                    </span>
                    <span
                      class="text-200--regular
                        {{item.rightColumn.changeClass}}
                        "
                    >
                      {{item.rightColumn.change}}
                    </span>
                    {{#if item.rightColumn.progressBarData}}
                      <div class="mt-100">
                        <PrismDataBar
                          @data={{item.rightColumn.progressBarData}}
                        />
                      </div>
                    {{/if}}
                    <span class="{{styles.label}} flex flex-row">
                      <span class="text-200--regular truncate">
                        {{item.rightColumn.label}}
                      </span>
                    </span>
                  </div>
                {{/if}}
              </div>
            </:content>
          </PrismCard>
        {{/if}}
      {{/each}}
    </div>
  </template>
}
